export enum NatureTypeEnum {
  CatalogActions = 'Catalogue actions',
  FSEFunded = 'Financée FSE',
  Others = 'Autres',
  CommunityWorkshop = 'Action',
  ActionOnPrescription = 'Action sur prescription',
  CommunitySupport = 'Atelier collectif',
}
